import DOMPurify from 'dompurify';
import {marked} from 'marked'


export function _generatedHTMLFromMarkdown(markdown) {
  return function() {
    return DOMPurify.sanitize(marked.parse(markdown));
  };
}
